import { render } from "./HeadCount.vue?vue&type=template&id=36bc25c2&scoped=true"
import script from "./HeadCount.vue?vue&type=script&lang=js"
export * from "./HeadCount.vue?vue&type=script&lang=js"

import "./HeadCount.vue?vue&type=style&index=0&id=36bc25c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bc25c2"]])

export default __exports__